<template>
  <div ref="detectWidth">
    <div
      :class="['pagination', themeClass, containerWidth > 400 ? 'large' : 'small']"
    >
      <select
        id="page-selecter"
        name="redirect to this page number"
        aria-label="redirect to the selected page"
        @change="onSelect"
      >
        <option
          v-for="i in totalPages"
          :key="i"
          :value="baseUrl +'?page=' + i"
          :selected="i == currentPage ? 'selected' : null"
        >
          {{ i }}
        </option>
      </select>
      <p class="selection-copy">
        {{ totalPageCopy }}
      </p>
      <span class="divider" />
      <a
        :href="previousActive ? previousUrl : null"
        :role="previousActive ? 'link' : null"
        :class="['previous-link' , previousClass]"
        :aria-label="ariaLabelPrevious ? ariaLabelPrevious : null"
        :aria-describedby="ariaDescribedbyPrevious ? ariaDescribedbyPrevious : null"
      >
        &lt;&nbsp;&nbsp;  <span class="link-content">{{ previousTitle }}</span>
      </a>
      <a
        :href="nextActive ? nextUrl : null"
        :role="nextActive ? 'link' : null"
        :class="['next-link', nextClass]"
        :aria-label="ariaLabelNext ? ariaLabelNext : null"
        :aria-describedby="ariaDescribedbyNext ? ariaDescribedbyNext : null"
      >
        <span class="link-content">{{ nextTitle }}</span> &nbsp;&nbsp;&gt;
      </a>
    </div>
  </div>
</template>

<script>
import i18n from '../i18n'

export default {
  name: 'WvcPagination',
  props: {
    /**
     * Use dark theme for component.
     */
    dark: {
      type: Boolean,
      default: false
    },
    totalPages: {
      type: Number,
      default: 1
    },
    totalPageCopy: {
      type: String,
      default: 'of 1 pages'
    },
    currentPage: {
      type: Number,
      default: 1
    },
    baseUrl: {
      type: String,
      default: '#'
    },
    previousTitle: {
      type: String,
      default: 'previous'
    },
    previousUrl: {
      type: String,
      default: '#'
    },
    previousActive: {
      type: Boolean,
      default: true
    },
    ariaLabelPrevious: {
      type: String,
      default: null
    },
    ariaDescribedbyPrevious: {
      type: String,
      default: null
    },
    nextTitle: {
      type: String,
      default: 'next'
    },
    nextUrl: {
      type: String,
      default: '#'
    },
    nextActive: {
      type: Boolean,
      default: true
    },
    ariaLabelNext: {
      type: String,
      default: null
    },
    ariaDescribedbyNext: {
      type: String,
      default: null
    }

  },
  /**
     * Hover state swaps icons
     */
  data: function () {
    return {
      containerWidth: 0
    }
  },

  computed: {
    themeClass() {
      return {
        'theme-light': !this.dark,
        'theme-dark': this.dark
      }
    },
    nextClass() {
      return {
        'link-disabled': !this.nextActive
      }
    },
    previousClass() {
      return {
        'link-disabled': !this.previousActive
      }
    }
  },
  mounted: function () {
    this.onResize()
    window.addEventListener('resize', this.onResize)
  },
  methods: {
    // this is triggered when the browser resizes
    onResize: function() {
      // this detects the width of my parent container, not browser width
      // const width = this.$refs.detectWidth.clientWidth
      const width = this.$refs.detectWidth.clientWidth
      this.containerWidth = width
    },
    onSelect: function (e) {
      const href = e.target.value
      // console.log(href)
      // this works, but cannot be tested in storybook
      window.location.href = href
    }
  },

  i18n
}
</script>

<style lang="scss" scoped>
.container {
  @include reset;
  display: inline-block;
}
p, a{
  display:inline;
}
#page-selecter{
  display:inline;
  height:20px;
  width:34px;
  float:left;
  margin:0 8px 0 0;;
  border:none;
  font-weight:bold;
  background-color:$sky-lighter;
    &:focus-visible{
      outline:none;
      border-radius:4px;
      box-shadow: 0 0 0 2px $blue-light;
  }
}
#page-selecter > option{
  // every os will replace this.
  width: 17px;
  height: 24px;
  margin: 0 4px 0 0;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  text-align: center;
}
.selection-copy{
  font-family: Karla;
  height: 24px;
  margin: 0 0 0 8px;
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color:$black;
}
.divider{
  margin:0 24px;
  height: 24px;
  border-right:1px solid grey;
}
.previous-link, .next-link{
  padding:0 1px;
  height: 24px;
  font-family: Karla;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  text-decoration:none;
  color:$black;
}
.previous-link{
  margin-right:16px;
}
.previous-link, .next-link{
  color:$black;
  text-decoration:none;
  &:hover{
    .link-content{
      text-decoration:underline;
    }
  }
    &:focus-visible{
    outline:none;
    box-shadow: 0 0 0 2px $blue-light;
  }
}
.link-disabled, .link-disabled a{
  color:$grey-light;
  &:hover{
    text-decoration:none;
    .link-content{
      text-decoration:none;
      }
  }
}
// ########################  dark theme css
.pagination.theme-dark{
  #page-selecter{
  display:inline;
  border-radius:4px;
    &:focus-visible{
      outline:none;
      border-radius:4px;
      box-shadow: 0 0 0 2px $blue-lighter;
  }
}
  .selection-copy{
    color:$white;
  }
  .previous-link, .next-link{
  color:$white;
  text-decoration:none;
    &:hover{
    // text-decoration:underline;
    .link-content{
      border-bottom:1px solid $white;
    }
  }
    &:focus-visible{
      outline:none;
      box-shadow: 0 0 0 2px $blue-lighter;
    }
    p,a{
      color:$white;
    }
  }
  .link-disabled{
    color:$grey;
    &:hover{
      .link-content{
        border-bottom:none;
      }
    }
  }
}
// ########################  mobile css
@include media('phone') {
   .divider{
    margin:0 12px;
}
 }
</style>
